import { values, flatten } from 'lodash'

import { getTransportationLabel } from '../lib/text.js'
import { getBI } from '../reservations/ReservationTools'
import { getTripBill } from '../../lib/TripTools'

/**
 * 
 */

const typeMeans = {
  city : "Transporte",
  activity : "Actividad",
  expense : "Gasto",
  hotel : "Hotel",
  other_expense : "Otro gasto",
}

const reservationMeans = {
  sn: "Sin reserva",
  nn: "No necesita",
  res: "Reservado",
  pag: "Pagado",
  wtf: "WTF"
}

export default function getPurchasesReportData(
  trips: Object[], 
  routes: Object, 
  activities: {[string]: Object}, 
  cities: {[string]: Object}, 
  reservations: {[string]: Object}, 
  isProductionIgnored: boolean,
  progressCallback: ?((number, number) => void)
): Promise<any[][]> 
{
  const purchasesTop = trips.length - 1

  // quiero mínimo 4 steps
  const step = Math.min(200, Math.floor(purchasesTop / 4))
  const stepResults = []

  // returns array of array of items/rows (bc bill > sections > items)
  function doTrip(t, i) {
    const name = (t.name && t.realName) ? `${t.realName} (${t.name})` : t.name || t.realName
    const bill = getTripBill(t, routes[t.mainRoute], activities, cities)

    if (progressCallback && (i % step == 0 || i == purchasesTop)) {
      progressCallback(i, purchasesTop)
    } 

    return bill.map((d) => (
      d.items
        .filter(i => (i.agendaItem ? !i.agendaItem.ref : true))
        .map((item) => {
          // #TODO replace with a `find` !
          const reserva = values(reservations).filter(r => `${r._id}`.replace(`${t._id}`, "") == ((item.type == "expense" && item.agendaItem.ref) || (item.type == "other_expense" && item._id) || item.key))[0]

          return [
            name,
            t._id,
            item.name,
            typeMeans[item.type],
            item.origin ? item.origin : "",
            item.destination ? item.destination : "",
            item.agendaItem && item.agendaItem.transport 
              ? getTransportationLabel(item.agendaItem.transport.means, {forceLanguage: "es"}) 
              : "",
            item.city ? item.city : "General",
            item.priceValue ? item.priceValue.toFixed(2) : 0,
            item.totalPriceValue 
              ? item.totalPriceValue.toFixed(2) 
              : (
                item.priceValue 
                  ? item.priceValue.toFixed(2) 
                  : 0
              ),
            item.useCustomFee ? (item.customFee - 1) * 100 : t.pGestion || 0,
            (item.price && item.price.perGroup && item.price.general) ? item.price.general.toFixed(2) : "",
            (item.price && !item.price.perGroup && item.price.general) ? item.price.general.toFixed(2) : "",
            (item.price && item.price.kidsDifferent && item.price.kids) ? item.price.kids.toFixed(2) : "",
            item.numRepetitions,
            item.date,
            reserva ? reserva._id : "",
            reserva ? reservationMeans[reserva.status] : "",
            reserva ? reserva.supplier : "",
            reserva ? getBI(reserva).toFixed(2) : "",
            reserva && reserva.finalPrice ? reserva.finalPrice.toFixed(2) : "",
            reserva ? reserva.receipt : "",
            reserva ? reserva.receiptDate : "",
          ]
        })
    ))
  }

  function doStep(from, endCallback) {
    const myData = trips.slice(from, from + step).map(doTrip)
    stepResults.push(myData)
    
    progressCallback(Math.min(from + step, purchasesTop), purchasesTop)

    // #TODO validate this is not an error-by-one. with several lengths!
    if (from + step <= purchasesTop) {
      setTimeout(() => doStep(from + step, endCallback), 100) 
    }
    else {
      setTimeout(() => endCallback(), 100) 
    }
  }

  return new Promise(yea => {
    function doEnd() {
      const tripResults = flatten(stepResults)
      const billSections = flatten(tripResults)
      const billItems = flatten(billSections)

      const final = [
        [
          "Cliente", 
          "Id Cliente", 
          "Actividad", 
          "Tipo", 
          "Origen",
          "Destino",
          "Tipo trans.",
          "Ciudad",
          "PVP/Dia",
          "PVP",
          "% Gestion",
          "€/Grupo",
          "€/Persona",
          "€/Niño",
          "Repeticiones",
          "Fecha",
          "Id Reserva",
          "Estado reserva",
          "Proveedor",
          "Base imponible",
          "Final",
          "Nº Factura",
          "Fecha Factura",
        ], 
        ...billItems
      ]

      yea(final)
    }

    doStep(0, doEnd)
  })
}
